//mui
import Dialog from '@mui/material/Dialog';

//mui
import { CardMedia } from '@mui/material';
import CardActionArea from '@mui/material/CardActionArea';
import StarIcon from '@mui/icons-material/Star';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import WeekendOutlinedIcon from '@mui/icons-material/WeekendOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';

//type
import { carType } from '../../api/Cars/type/CarsType';

//css file
import styles from "./BestCarDetails.module.css"


//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../../translate/i18n';

const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;


interface bestCarDetailsProps {
    selectedCar: carType | null,
    setSelectedCar: (selectedCar: carType | null) => void
    openBestCarDetails: boolean,
    setOpenBestCarDetails: (openBestCarDetails: boolean) => void
}
const CarDetails = ({selectedCar, setSelectedCar, openBestCarDetails, setOpenBestCarDetails,}:bestCarDetailsProps) => {
    console.log("test")
    const {t} = useTranslation()
    if (!selectedCar) return null;
    return (
        <Dialog
        open={openBestCarDetails}
        onClose={()=>{setOpenBestCarDetails(false); setSelectedCar(null)}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        >
        <div className="overflow-hidden">
        <div>
            <CardActionArea className={` ${i18n.language === "en" ? `ltrSwiper ${styles.ltrSwiper}` : `rtlSwiper ${styles.rtlSwiper}`}`}>
                <Swiper
                key={i18n.language}
                dir={i18n.language === "ar" ? "rtl" : "ltr"}
                loop={true}
                spaceBetween={30}
                navigation
                pagination={{ clickable: true }}
                modules={[Navigation, Pagination]}
                className={`roomCardSwiper ${styles.roomCardSwiper}`}
            >
                {selectedCar.primary_images.map((img, index) => (
                <SwiperSlide 
                className="
                !flex 
                justify-center 
                items-center 
                rounded-[16px]" 
                key={index}>
                    <CardMedia
                    component="img"
                    src={`${storageURL}/${img.url}`}
                    className='!object-left-bottom'
                    alt="no_photo"
                    />
                </SwiperSlide>
                ))}
                </Swiper>
            </CardActionArea>
        </div>
        <div className="p-3 mt-3">
            <p className="font-[600]">{selectedCar.brand.name}</p>
            <div className="text-[#7F7F7F] text-sm">
            <div className="flex items-center gap-2 mt-2">
                <StarIcon  className="!text-[#FF8F3A]"/>
                <p>5.0</p>
            </div>
            <div className="flex items-center gap-2 mt-2">
                <LocationOnOutlinedIcon/>
                <p>Damascus, SY</p>
            </div>
            <div className="flex items-center gap-2 mt-2">
                <WeekendOutlinedIcon/>
                <p>{selectedCar.seating_capacity} {t("seats")}</p>
            </div>
            <div className="flex justify-between gap-1 flex-wrap">
                <div className={`${selectedCar.is_daily !== 0 ? "" : "hidden"} flex items-center gap-2 mt-2`}>
                <MonetizationOnOutlinedIcon/>
                <p>{selectedCar.daily_price} / {t("day")}</p>
                </div>
                <div className={`${selectedCar.is_weekly !== 0 ? "" : "hidden"} flex items-center gap-2 mt-2`}>
                <MonetizationOnOutlinedIcon/>
                <p>{selectedCar.weekly_price} / {t("week")}</p>
                </div>
                <div className={`${selectedCar.is_monthly !== 0 ? "" : "hidden"} flex items-center gap-2 mt-2`}>
                <MonetizationOnOutlinedIcon/>
                <p>{selectedCar.monthly_price} / {t("month")}</p>
                </div>
            </div>
            </div>
        </div>
        </div>
        </Dialog>
    )
}

export default CarDetails